/**
 * @module invoiceStatus
 * @description A list of invoiceStatus
 */

export const invoiceStatus = [
	'draft',
	'sent',
	'partial',
	'paid',
	'unpaid',
	'overdue',
	'cancelled',
] as const;
export type InvoiceStatus = (typeof invoiceStatus)[number];
